
import "/home/vsts/work/1/s/src/layouts/rightContentRender/index.module.less?modules";
export default {"wrap": `wrap-FZjt67y8`}
